var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"zj-moble-app-page"},[_c('div',{staticClass:"zj-mt-content"},[_c('div',{ref:"map-mapview",staticClass:"zj-mt-mapview"},[_c('ZJMobileMapViewApp',{attrs:{"MapKey":"MobileHotMap"}})],1)])])
}
var staticRenderFns = []

export { render, staticRenderFns }